<template>
  <page>
    <page-title v-t="'p.passwordResetPage.title'"/>
    <password-reset-form />
  </page>
</template>

<script>
import { mapActions } from 'vuex'
import PageMixin from '@/mixins/pages/Page'
import PasswordResetForm from '@/components/auth/PasswordResetForm'

export default {
  name: 'PasswordResetPage',
  mixins: [PageMixin],
  components: {
    PasswordResetForm
  },
  methods: {
    ...mapActions({
      resetForm: 'passwordResetForm/reset',
    })
  },
  created () {
    this.$emit('loadingDone')
  },
  beforeDestroy () {
    this.resetForm()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/PasswordResetPage.vue